/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */

import MDCFoundation from '@material/base/foundation';
import MDCTextFieldCharacterCounterAdapter from './adapter';
import {cssClasses, strings} from './constants';

/**
 * @extends {MDCFoundation<!MDCTextFieldCharacterCounterAdapter>}
 * @final
 */
class MDCTextFieldCharacterCounterFoundation extends MDCFoundation {
  /** @return enum {string} */
  static get cssClasses() {
    return cssClasses;
  }

  /** @return enum {string} */
  static get strings() {
    return strings;
  }

  /**
   * {@see MDCTextFieldCharacterCounterAdapter} for typing information on parameters and return
   * types.
   * @return {!MDCTextFieldCharacterCounterAdapter}
   */
  static get defaultAdapter() {
    return /** @type {!MDCTextFieldCharacterCounterAdapter} */ ({
      setContent: () => {},
    });
  }

  /**
   * @param {!MDCTextFieldCharacterCounterAdapter} adapter
   */
  constructor(adapter) {
    super(Object.assign(MDCTextFieldCharacterCounterFoundation.defaultAdapter, adapter));
  }

  /**
   * @param {number} currentLength
   * @param {number} maxLength
   */
  setCounterValue(currentLength, maxLength) {
    currentLength = Math.min(currentLength, maxLength);
    this.adapter_.setContent(`${currentLength} / ${maxLength}`);
  }
}

export default MDCTextFieldCharacterCounterFoundation;



// WEBPACK FOOTER //
// ./packages/mdc-textfield/character-counter/foundation.js